const ACTIONS = {
    WINDOW_SIZE_CHANGED: 'WINDOW/SIZE_CHANGED',
    WINDOW_SCROLLED: 'WINDOW/SCROLLED',
    SET_STICKY_POSITION: 'WINDOW/SET_STICKY_POSITION',
    STICKY_POSITION_UPDATED: 'WINDOW/STICKY_POSITION_UPDATED',
    WINDOW_DEVICE_UPDATED: 'WINDOW/DEVICE_UPDATED'
};

const ACTION_CREATORS = {
    windowSizeChanged(height, width, yPosition) {
        return {
            type: ACTIONS.WINDOW_SIZE_CHANGED,
            payload: {
                height,
                width,
                yPosition
            }
        };
    },
    windowScrolled(yPosition) {
        return {
            type: ACTIONS.WINDOW_SCROLLED,
            payload: {
                yPosition
            }
        };
    },
    setStickyPosition(key, value) {
        return {
            type: ACTIONS.SET_STICKY_POSITION,
            payload: {
                key,
                value
            }
        };
    },
    stickyPositionUpdated(stickyMap) {
        return {
            type: ACTIONS.STICKY_POSITION_UPDATED,
            payload: {
                stickyMap
            }
        };
    },
    windowDeviceUpdated(deviceState, windowSize, device, deviceSize) {
        return {
            type: ACTIONS.WINDOW_DEVICE_UPDATED,
            payload: {
                deviceState,
                windowSize,
                device,
                deviceSize
            }
        };
    }
};

export default {...ACTIONS, ...ACTION_CREATORS};
